export const prepareToSendObject = onSubmitFunc => data => {
  const transformData = data

  transformData.unitPrice = parseInt(transformData.unitPrice, 10)

  transformData.category = transformData.category.value
  onSubmitFunc(transformData)
}
